export default "__VITE_ASSET__blRS2owL__"